import { render } from "./CustomerServiceBar.vue?vue&type=template&id=a533db08&scoped=true&ts=true"
import script from "./CustomerServiceBar.vue?vue&type=script&lang=ts"
export * from "./CustomerServiceBar.vue?vue&type=script&lang=ts"

import "./CustomerServiceBar.vue?vue&type=style&index=0&id=a533db08&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a533db08"]])

export default __exports__